import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../../core/Store';
import * as Styles from './Styles';
import NavButton from './NavButton';
import SvgLogoMentor from '../../../others/svg_dist/LogoMentor';
import * as AppManager from '../../../reducers/ui/app';
import { history } from '../../../core/history';
import { Routing } from '../../../core/Routing';
import SvgBars from '../../../others/svg_dist/Bars';
import SvgCancel from '../../../others/svg_dist/Cancel';
import { gotoPage } from '../../../utils/gotoPage';
import SvgLogoErgoHestia from '../../../others/svg_dist/LogoErgoHestia';
import * as FormManager from '../../../reducers/ui/form';
import SvgCart from '../../../others/svg_dist/Cart';
import * as DictionariesRisksSelectors from '../../../reducers/data/dictionaries/risks/selectors';
import * as MobileSummaryModalManager from '../../../reducers/ui/mobileSummaryModal';
import SvgLogoWopr from '../../../others/svg_dist/LogoWopr';

type State = {
	sideMenuActive: boolean;
	contactButtonActive: boolean;
};

class NavbarComponent extends React.Component<PropsFromRedux, State> {
	state: State = {
		sideMenuActive: false,
		contactButtonActive: false,
	};

	contactButtonOnClick = () => {
		const tempAnchor = document.createElement('a');
		tempAnchor.href = '#kontakt';
		tempAnchor.click();
		this.setState({ ...this.state, contactButtonActive: true });

		setTimeout(() => {
			const close = () => {
				this.setState({ ...this.state, contactButtonActive: false });
				document.removeEventListener('scroll', close);
			};
			document.addEventListener('scroll', close);
		}, 100);
	};

	startButtonOnClick = () => {
		FormManager.clearFullForm();
		gotoPage(Routing.main.start);
	};

	MULTIPLY_FACTOR = 1.5;

	calcTotalPrice = () => {
		const allSelectedRisks = this.props.allRisksDict.filter((el) =>
			this.props.allSelectedRisksIds.includes(el.riskId)
		);
		const mappedSelectedRisks = allSelectedRisks.map((el) => {
			if (el.riskId <= 6 && this.props.extendedOcCoverageSelected) {
				return {
					...el,
					riskContribution:
						el.riskContribution * this.MULTIPLY_FACTOR,
				};
			}
			return el;
		});

		if (mappedSelectedRisks.length === 0) {
			return '0.00';
		}

		if (mappedSelectedRisks.length === 1) {
			return mappedSelectedRisks[0].riskContribution;
		}

		return mappedSelectedRisks
			.map((el) => el.riskContribution)
			.reduce((prev, current) => (prev += current));
	};

	renderMobileSideMenu = (location: string) => {
		return (
			<Styles.SideMenuContainer>
				<NavButton
					label="START"
					active={
						!this.state.contactButtonActive &&
						location === Routing.main.start
					}
					onClick={() => this.startButtonOnClick()}
				/>
				<NavButton
					label="ZGŁOSZENIE SZKODY"
					active={
						!this.state.contactButtonActive &&
						location === Routing.main.reportDamage
					}
					onClick={() => gotoPage(Routing.main.reportDamage)}
				/>
				<NavButton
					label="DOKUMENTY"
					active={
						!this.state.contactButtonActive &&
						location === Routing.main.documents
					}
					onClick={() => gotoPage(Routing.main.documents)}
				/>
				<NavButton
					label="FAQ"
					active={
						!this.state.contactButtonActive &&
						location === Routing.main.faq
					}
					onClick={() => gotoPage(Routing.main.faq)}
				/>
				{location !== Routing.main.paymentSuccess && (
					<NavButton
						label="KONTAKT"
						active={this.state.contactButtonActive}
						onClick={() => this.contactButtonOnClick()}
					/>
				)}
			</Styles.SideMenuContainer>
		);
	};

	renderHamburger = () => {
		return (
			<Styles.HamburgerButton
				onClick={() =>
					this.setState({
						...this.state,
						sideMenuActive: !this.state.sideMenuActive,
					})
				}
			>
				{this.state.sideMenuActive ? <SvgCancel /> : <SvgBars />}
			</Styles.HamburgerButton>
		);
	};

	renderFullWidthNav = (location: string) => {
		return (
			<Styles.FullWidthNavContainer>
				<NavButton
					label="START"
					active={
						!this.state.contactButtonActive &&
						location === Routing.main.start
					}
					onClick={() => this.startButtonOnClick()}
				/>
				<NavButton
					label="ZGŁOSZENIE SZKODY"
					active={
						!this.state.contactButtonActive &&
						location === Routing.main.reportDamage
					}
					onClick={() => gotoPage(Routing.main.reportDamage)}
				/>
				<NavButton
					label="DOKUMENTY"
					active={
						!this.state.contactButtonActive &&
						location === Routing.main.documents
					}
					onClick={() => gotoPage(Routing.main.documents)}
				/>
				<NavButton
					label="FAQ"
					active={
						!this.state.contactButtonActive &&
						location === Routing.main.faq
					}
					onClick={() => gotoPage(Routing.main.faq)}
				/>
				{location !== Routing.main.paymentSuccess && (
					<NavButton
						label="KONTAKT"
						active={this.state.contactButtonActive}
						onClick={() => this.contactButtonOnClick()}
					/>
				)}
				<Styles.FullNavDecor />
				<SvgLogoMentor />
				<SvgLogoErgoHestia />
				<SvgLogoWopr />
			</Styles.FullWidthNavContainer>
		);
	};

	render() {
		const location = history.location.pathname;
		const isTransparent = this.props.variant === 'transparent';
		const isMobileWidth = this.props.viewportWidth <= 1200;

		return (
			<Styles.Wrapper
				isDocked={!this.props.isBodyScrolled}
				isTransparent={isTransparent}
				style={{
					justifyContent: isMobileWidth ? 'flex-start' : '',
					backdropFilter:
						isMobileWidth && this.state.sideMenuActive
							? 'unset'
							: '',
				}}
			>
				{this.state.sideMenuActive &&
					isMobileWidth &&
					this.renderMobileSideMenu(location)}
				{this.props.contributionSum &&
					this.props.viewportWidth <= 900 && (
						<Styles.MobileSum
							onClick={() =>
								MobileSummaryModalManager.openModal()
							}
						>
							<SvgCart />
							<p>{this.calcTotalPrice()} zł</p>
						</Styles.MobileSum>
					)}
				{isMobileWidth && this.renderHamburger()}
				{!isMobileWidth && this.renderFullWidthNav(location)}
			</Styles.Wrapper>
		);
	}
}

interface Own {
	variant: 'transparent' | 'blue';
}

const connector = connect(
	(state: AppState, own: Own) => {
		const risksKop = DictionariesRisksSelectors.getRisksKop(state);
		const risksNnw = DictionariesRisksSelectors.getRisksNnw(state);
		const risksNnwKlauzule =
			DictionariesRisksSelectors.getRisksNnwKlauzule(state);
		const risksOc = DictionariesRisksSelectors.getRisksOc(state);

		return {
			isBodyScrolled: AppManager.Selectors.getIsBodyScrolled(state),
			viewportWidth: AppManager.Selectors.getViewportWidth(state),
			contributionSum: FormManager.Selectors.getContributionSum(state),
			allRisksDict: [
				...risksKop,
				...risksNnw,
				...risksNnwKlauzule,
				...risksOc,
			],
			allSelectedRisksIds:
				FormManager.Selectors.getSelectedRisksIds(state),
			extendedOcCoverageSelected:
				FormManager.Selectors.getExtendedOcCoverageSelected(state),
		};
	},
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Navbar = connector(NavbarComponent);
export default Navbar;
